import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { FormError } from "@/components/ui/form-error";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useMutation } from "@apollo/client";
import { SEND_INVITATION } from "../../../../GraphQL/settings/mutations";
import { EToastColorStatus, EToastPosition } from "../../../../interfaces";

const InviteEmailSchema = Yup.object().shape({
  email: Yup.string().email("Invalid email").required("Required"),
});

interface IInviteModalProps {
  showModalInvite: boolean;
  onCloseModalInvite: () => void;
  onHandleCreateToast: (
    color: EToastColorStatus,
    position: EToastPosition,
    message: string,
  ) => void;
}

const InviteUserModal = ({
  showModalInvite,
  onCloseModalInvite,
  onHandleCreateToast = () => {},
}: IInviteModalProps) => {
  const [inviteEmail] = useMutation(SEND_INVITATION, {
    onCompleted(data) {
      if (data?.sendInvitation?.ok) {
        onHandleCreateToast(
          EToastColorStatus.SUCCESS,
          EToastPosition.BOTTOM_END,
          "Successfully invited!",
        );
      } else {
        onHandleCreateToast(
          EToastColorStatus.FAILED,
          EToastPosition.BOTTOM_END,
          "Something went wrong!",
        );
      }
    },
    onError() {
      onHandleCreateToast(
        EToastColorStatus.FAILED,
        EToastPosition.BOTTOM_END,
        "Something went wrong!",
      );
    },
  });

  const formik = useFormik({
    initialValues: {
      email: '',
    },
    validationSchema: InviteEmailSchema,
    onSubmit: (values) => {
      const { email } = values;
      inviteEmail({ variables: { email }});
      onCloseModalInvite();
    },
  });

  const { errors, touched } = formik;

  return (
    <Dialog open={showModalInvite} onOpenChange={onCloseModalInvite}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Invite a user</DialogTitle>
        </DialogHeader>
        <form onSubmit={formik.handleSubmit} className="space-y-4">
          <p>Enter email address of someone you would like to invite to join your company on Role Relay</p>
          <div className="space-y-2">
            <Label htmlFor="email">Email*</Label>
            <Input
              id="email"
              name="email"
              type="email"
              placeholder="e.g. your@mail.com"
              onChange={formik.handleChange}
            />
            <FormError>{errors.email && touched.email ? errors?.email : null}</FormError>
          </div>
        </form>
        <DialogFooter>
          <Button variant="default" onClick={() => formik.submitForm()}>
            Send
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

export default InviteUserModal;
